module.exports = __webpack_public_path__ + "static/img/product_society_society_vx.672cda7.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/product/product_society_society_vx.png
// module id = TiEI
// module chunks = 0